import {Tooltip} from '@mantine/core';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import CreateEntryFromTemplateModal, {
  CreateEntryFromTemplateModalProps,
} from 'notebook/entry-templates/CreateEntryFromTemplateModal/CreateEntryFromTemplateModal';
import LegacyCreateEntryFromTemplateModalClass from 'notebook/entry-templates/LegacyCreateEntryFromTemplateModal';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import legacyRunModal from 'ui-library/legacyRunModal';

export type CreateEntryFromTemplateSubmission = Parameters<
  CreateEntryFromTemplateModalProps['onRequestSubmit']
>[0];

interface CreateEntryFromTemplateButtonBaseProps {
  buttonId: string;
  buttonText: string;
  disabledMessage: string | null;
  filterTemplateIds?: Array<string>;
  onRequestSubmit: (submission: CreateEntryFromTemplateSubmission) => void;
  showUnpublishedCollectibles?: boolean;
  templateId: string;
}

export default function CreateEntryFromTemplateButtonBase({
  buttonId,
  buttonText,
  disabledMessage,
  filterTemplateIds,
  onRequestSubmit,
  showUnpublishedCollectibles,
  templateId,
}: CreateEntryFromTemplateButtonBaseProps): JSX.Element {
  const showModal = (): void => {
    // TODO(BNCH-38468): Remove feature flag after rollout and discontinue legacy modal.
    if (!BenchlingConfig.ELN_ENABLE_SCHEMA_ON_ENTRY_CREATE_MODAL) {
      LegacyCreateEntryFromTemplateModalClass.open({
        filterTemplateIds,
        initialTemplateId: templateId,
        initialFolderId: FolderDefaults.get(FolderDefaultsKey.NOTEBOOK),
        onRequestSubmit,
        showUnpublishedCollectibles,
      });
    } else {
      legacyRunModal(CreateEntryFromTemplateModal, {
        filterTemplateIds,
        initialTemplateId: templateId,
        initialFolderId: FolderDefaults.get(FolderDefaultsKey.NOTEBOOK),
        onRequestClose: () => {},
        onRequestSubmit,
        isTemplateSelectorDisabled: false,
        showUnpublishedCollectibles,
      });
    }
  };

  return (
    <Tooltip
      label={disabledMessage ?? ''}
      disabled={disabledMessage == null}
      multiline={true}
      width={240}
      // The toolbar panel clips its overflow, which would cut the label off at the panel edge.
      withinPortal={true}
    >
      {/* Tooltip attaches its reference ref to its child, and ui-library's Button is not a forwardRef
          component, so it needs a wrapper to hang that ref on. Keep the wrapper a block element so the
          button still sizes itself to the full panel width. */}
      <div>
        <Button
          id={buttonId}
          buttonStyle={ButtonStyle.SECONDARY}
          fullWidth={true}
          size={ButtonSize.SMALL}
          disabled={disabledMessage != null}
          onClick={showModal}
          text={buttonText}
        />
      </div>
    </Tooltip>
  );
}
